import { create } from 'zustand';
import { persist } from 'zustand/middleware';

type CurrentStoreState = {
  currentStoreId: string | null;
  setCurrentStoreId: (id: string | null) => void;
};

export const useCurrentStore = create<CurrentStoreState>()(
  persist(
    (set) => ({
      currentStoreId: null,
      setCurrentStoreId: (id) => set({ currentStoreId: id }),
    }),
    { name: 'chhabighar.currentStoreId' },
  ),
);
